import React from "react";
import Contact from "../Contact/Contact";
import Home from "../Home/Home";
import Services from "../Services/Services";

const Homepage = () => {
  return (
    <>
      <Home />
      <Services />
      <Contact />
    </>
  );
};

export default Homepage;
